import { makeStyles } from '@mui/styles';

export const useChannelTableStyle = makeStyles(() => ({
  buttonsContainer: {
    display: 'flex',
    gap: '1rem',
  },
}));
